var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6571_6644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9495 10.3638C19.3401 9.97323 19.3401 9.34007 18.9495 8.94955C18.559 8.55902 17.9259 8.55902 17.5353 8.94955L14.0002 12.4847L10.4648 8.94937C10.0743 8.55884 9.44116 8.55884 9.05063 8.94937C8.66011 9.33989 8.66011 9.97305 9.05063 10.3636L12.586 13.8989L9.05076 17.4341C8.66023 17.8246 8.66023 18.4578 9.05076 18.8483C9.44128 19.2389 10.0744 19.2389 10.465 18.8483L14.0002 15.3131L17.5352 18.8482C17.9257 19.2387 18.5589 19.2387 18.9494 18.8482C19.3399 18.4576 19.3399 17.8245 18.9494 17.4339L15.4144 13.8989L18.9495 10.3638Z",
    fill: "url(#paint0_linear_6571_6644)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "url(#paint1_linear_6571_6644)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6571_6644",
    x1: 8.08854,
    y1: 17.8861,
    x2: 19.9115,
    y2: 9.91146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6571_6644",
    x1: 11.2787,
    y1: 28,
    x2: 16.7213,
    y2: -1.65989e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6571_6644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/Clean.58acfca86cc860616d37e012b54c17d1.svg";
export { ForwardRef as ReactComponent };